import { isOpenPartnerProductOrderItemsSaveModal } from "@/atoms/item/is-open-partner-product-order-items-save-modal";
import { isOpenMovePartnerQuotePageModal } from "@/atoms/quote/is-open-move-partner-quote-page-modal";
import { ordererState, OrdererState } from "@/atoms/quote/orderer-state";
import { profileState } from "@/atoms/user/profile-state";
import { GLOBAL_ERROR } from "@/common/constant/global-error";
import { ButtonColor } from "@/common/enum/button-color";
import { TextInputColor } from "@/common/enum/text-input-color";
import { quoteService } from "@/services/quote-service";
import { QuoteDetailDto } from "@/types/dto/quote-detail-dto";
import { Button, Modal, TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { QuotePDFDownloadButton } from "../button/QuotePDFDownloadButton";
import { TextInputLabel } from "../label/TextInputLabel";
import { Body14Regular } from "../typography/Body14Regular";
import { H4 } from "../typography/H4";

export const PartnerProductOrderItemsSaveModal = () => {
  const [items, setItems] = useRecoilState(
    isOpenPartnerProductOrderItemsSaveModal
  );
  const [isMovePartnerQuotePageMadalOpen, setIsMovePartnerQuotePageMadalOpen] =
    useRecoilState(isOpenMovePartnerQuotePageModal);
  const [profile, setProfile] = useRecoilState(profileState);
  const [quote, setQuote] = useState<QuoteDetailDto | undefined>();
  const [orderer, setOrderer] = useRecoilState<OrdererState>(ordererState);
  const [aggregateErrors, setAggregateErrors] = useState({
    ordererBusinessName: "", // 파트너 이름
    ordererPhone: "", // 파트너 연락처
    ordererName: "", // 고객명
  });

  const isButtonActive =
    !!orderer.ordererBusinessName &&
    !!orderer.ordererPhone &&
    !!orderer.ordererName;

  const onClose = () => {
    setItems([]);
    setQuote(undefined);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setOrderer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const createQuote = async () => {
    try {
      const response = await quoteService.create({
        ordererBusinessName: orderer.ordererBusinessName,
        ordererPhone: orderer.ordererPhone,
        ordererName: orderer.ordererName,
        constructionName: orderer.constructionName,
        constructionWorkName: orderer.constructionWorkName,
        items: items.map((item) => ({
          itemId: item.childItem.id,
          quantity: item.quantity,
          memoItems: item.childItem.memoItems,
        })),
      });
      if (!response.ok) {
        return alert(GLOBAL_ERROR);
      }
      const responseByQuoteId = await quoteService.getById(response.data.id);
      if (!response.ok) {
        return alert(GLOBAL_ERROR);
      }
      setQuote(responseByQuoteId.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveButtonClick = () => {
    if (quote) {
      setIsMovePartnerQuotePageMadalOpen(quote?.id);
    }
  };

  useEffect(() => {
    if (!profile) {
      return;
    }

    setOrderer({
      ordererBusinessName: profile.businessName || "",
      ordererPhone: profile.phone || "",
      ordererMail: profile.email || "",
      ordererName: profile.name || "",
      constructionName: "",
      constructionWorkName: "",
    });
  }, []);

  if (items.length === 0) {
    return null;
  }

  return (
    <Modal size="4xl" show={true} onClose={onClose}>
      <Modal.Header>
        <H4 className="text-semantic-text-heading">견적서 저장</H4>
      </Modal.Header>
      <Modal.Body>
        <div className="flex gap-[10px]">
          <div className="flex flex-col text-semantic-text-body w-[400px]">
            <Body14Regular>견적서 효력은 발급일 기준 30일입니다.</Body14Regular>
            <Body14Regular>
              기간 인센티브 할인이 적용된 견적서일 경우, 할인율에 변동이 있을 수
            </Body14Regular>
            <Body14Regular>있습니다.</Body14Regular>
            <div className="flex items-center justify-center">
              <img
                src="/img/quotation-save-icon.png"
                alt="pdf"
                className="mt-[16px] w-[285px] h-[285px]"
              />
            </div>
          </div>
          <div className="flex flex-col w-[400px]">
            <TextInputLabel required>공급자 정보</TextInputLabel>
            <TextInput
              required
              className="w-full"
              placeholder="파트너명을 입력해주세요"
              name="ordererBusinessName"
              value={orderer.ordererBusinessName}
              onChange={handleInputChange}
              color={
                !!aggregateErrors.ordererBusinessName
                  ? TextInputColor.FAILURE
                  : TextInputColor.GRAY
              }
            />
            <div className="mt-[16px]" />
            <TextInputLabel required>공급자 연락처</TextInputLabel>
            <TextInput
              required
              className="w-full"
              placeholder="공급자 연락처를 입력해주세요"
              name="ordererPhone"
              value={orderer.ordererPhone}
              onChange={handleInputChange}
              color={
                !!aggregateErrors.ordererPhone
                  ? TextInputColor.FAILURE
                  : TextInputColor.GRAY
              }
            />
            <div className="mt-[16px]" />
            <TextInputLabel required>고객명</TextInputLabel>
            <TextInput
              required
              className="w-full"
              placeholder="고객명을 입력해주세요"
              name="ordererName"
              value={orderer.ordererName}
              onChange={handleInputChange}
              color={
                !!aggregateErrors.ordererName
                  ? TextInputColor.FAILURE
                  : TextInputColor.GRAY
              }
            />
            <div className="mt-[16px]" />
            <TextInputLabel>공사명</TextInputLabel>
            <TextInput
              className="w-full"
              placeholder="공사명을 입력해주세요"
              name="constructionName"
              value={orderer.constructionName}
              onChange={handleInputChange}
              color={TextInputColor.GRAY}
            />
            <div className="mt-[16px]" />
            <TextInputLabel>공종명</TextInputLabel>
            <TextInput
              className="w-full"
              placeholder="공종명을 입력해주세요"
              name="constructionWorkName"
              value={orderer.constructionWorkName}
              onChange={handleInputChange}
              color={TextInputColor.GRAY}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {quote ? (
          <div onClick={handleSaveButtonClick}>
            <QuotePDFDownloadButton quoteDetail={quote} profile={profile}>
              <Button
                className="w-[118px] h-[42px]"
                color={isButtonActive ? ButtonColor.PRIMARY : ""}
                disabled={!isButtonActive}
              >
                PDF 저장하기
              </Button>
            </QuotePDFDownloadButton>
          </div>
        ) : (
          <Button
            className="w-[118px] h-[42px]"
            color={isButtonActive ? ButtonColor.PRIMARY : ""}
            disabled={!isButtonActive}
            onClick={createQuote}
          >
            견적서 저장
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
